import React, { FC } from 'react';

import styled, { css } from 'styled-components/macro';

import { SpaceVariants } from 'theme';
import { VariantsStyles, FontVariants } from 'components/Typography';

const Justify = {
    center: css`
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: center;
    `,

    end: css`
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: flex-end;
    `,

    start: '',
};

const Wrapper = styled.div<{
    $font: FontVariants;
    $align: 'left' | 'center' | 'right';
    $justify: 'start' | 'center' | 'end';
    article?: boolean;
    spaceBottom?: SpaceVariants;
    spaceTop?: SpaceVariants;
}>`
    text-align: ${({ $align }) => $align};
    ${({ $justify }) => Justify[$justify]};

    ${({ spaceBottom, theme }) =>
        spaceBottom &&
        css`
            margin-bottom: ${theme.space[spaceBottom]};
        `}

    ${({ spaceTop, theme }) =>
        spaceTop &&
        css`
            margin-top: ${theme.space[spaceTop]};
        `};

    img {
        display: block;
        max-width: 100%;
    }

    img,
    ul,
    ol,
    p {
        ${({ $font }) => VariantsStyles[$font]}

        &:not(:first-child) {
            margin-top: ${({ theme }) => theme.space.base};
        }
    }

    ul,
    ol {
        list-style-position: inside;
    }

    li {
        margin-bottom: ${({ theme }) => theme.space.tiny};
    }

    a {
        ${({ $font }) => VariantsStyles[$font]}
        cursor: pointer;
        font-weight: 500;
        text-decoration: underline;
        &:hover {
            color: ${({ theme }) => theme.colors.brand};
        }
    }
`;

export type TextProps = {
    /** Alignment of the buttons */
    align: 'left' | 'center' | 'right';

    /** Justify the text */
    justify?: 'start' | 'center' | 'end';

    spaceBottom?: SpaceVariants;
    spaceTop?: SpaceVariants;

    font?: FontVariants;
};

const Text: FC<TextProps & React.HTMLAttributes<HTMLDivElement>> = ({
    align,
    justify,
    font = 'bodys',
    ...rest
}) => {
    return (
        <Wrapper
            $font={font}
            $align={align}
            $justify={justify ? justify : 'start'}
            {...rest}
        >
            {rest.children}
        </Wrapper>
    );
};

export default Text;
